import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { PROJECTS } from "../mock";
import { ArrowUpRight, ArrowLeft, ArrowRight } from "lucide-react";

export default function CaseStudies() {
  const ref = useRef(null);
  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.7, behavior: "smooth" });
  };

  return (
    <section className="bg-ink text-bone py-24 lg:py-36 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="rv">
            <div className="text-eyebrow text-amber mb-5">— 003 • Recent Case Studies</div>
            <h2 className="font-display-tight text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-bone max-w-3xl text-balance">
              A selection of <span className="italic font-display">finished work.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3 rv">
            <button onClick={() => scrollBy(-1)} className="h-12 w-12 border border-line-light flex items-center justify-center hover:bg-amber hover:text-ink hover:border-amber transition-colors" aria-label="previous"><ArrowLeft className="w-4 h-4" /></button>
            <button onClick={() => scrollBy(1)} className="h-12 w-12 border border-line-light flex items-center justify-center hover:bg-amber hover:text-ink hover:border-amber transition-colors" aria-label="next"><ArrowRight className="w-4 h-4" /></button>
            <Link to="/projects" className="ml-4 text-eyebrow text-amber link-line">View all —</Link>
          </div>
        </div>
      </div>

      <div ref={ref} className="h-strip px-6 lg:px-10 max-w-[1440px] mx-auto">
        {PROJECTS.slice(0, 8).map((p, i) => (
          <Link key={p.id} to="/projects" className="group block">
            <div className="relative overflow-hidden aspect-[4/5] mb-5">
              <img src={p.thumb} alt={p.title} className="img-zoom w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent opacity-70 group-hover:opacity-30 transition-opacity" />
              <div className="absolute top-5 left-5 text-eyebrow text-bone/80 bg-black/25 backdrop-blur border border-bone/15 px-2.5 py-1">
                {p.category}
              </div>
              <div className="absolute top-5 right-5 h-10 w-10 bg-bone/0 group-hover:bg-amber border border-bone/30 group-hover:border-amber flex items-center justify-center transition-all">
                <ArrowUpRight className="w-4 h-4 group-hover:text-ink" />
              </div>
            </div>
            <div className="flex items-baseline justify-between gap-4">
              <div>
                <div className="text-eyebrow text-bone/50 mb-1">{String(i + 1).padStart(2, "0")} — {p.location}</div>
                <h3 className="font-display text-3xl text-bone leading-tight">{p.title}</h3>
                <p className="text-bone/60 text-sm mt-1">{p.scope} · {p.year}</p>
              </div>
            </div>
          </Link>
        ))}
        {/* End card */}
        <Link to="/projects" className="group flex flex-col items-center justify-center border border-line-light hover:border-amber hover:bg-amber/10 transition-colors">
          <div className="font-display text-4xl text-bone group-hover:text-amber">Browse all →</div>
          <div className="text-eyebrow text-bone/50 mt-3">{PROJECTS.length} projects</div>
        </Link>
      </div>
    </section>
  );
}
